document.addEventListener('click', function (e) {
  const details = document.querySelector('.custom-share-menu details');
  if (details && !details.contains(e.target)) {
    details.removeAttribute('open');
  }
});

const btn = document.getElementById("copy-link-btn");
  const toast = document.getElementById("copy-toast");

  btn.addEventListener("click", function () {
    navigator.clipboard.writeText(window.location.href).then(() => {
      toast.classList.add("show");
  
      // Hide after 2.5 seconds
      setTimeout(() => {
        toast.classList.remove("show");
        toast.classList.add("hide");
      }, 2500);
  
      // Reset hide class after animation ends
      setTimeout(() => {
        toast.classList.remove("hide");
      }, 3000);
  });
});